import React, { useEffect, useState } from 'react'
import { FormProvider, Resolver, useForm, } from 'react-hook-form';
import * as myconst from "../../constants/index"
import _ from "lodash";
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import StepFive from './StepFive';
import StepSix from './StepSix';
import StepSeven from './StepSeven';
import StepEight from './StepEight';
import { Step, Stepper } from 'react-form-stepper';
import { handleLoader } from 'redux/counterSlice';
import { toast, ToastContent } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { addOrUpdateButterPieConfigurations, generateButterPiePdf, getButterPieConfigurations, getCategory, regenerateCategory } from 'services/butterPieService';
import ReactMarkdown from 'react-markdown';
import styles from 'assets/styles/ai-chat-bot/markdownRenderer.module.css';
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string, number, date, InferType, array } from 'yup';

const defaultStyle = {
    activeBgColor: '#ed1d24',
    activeTextColor: 'transparent',
    completedBgColor: '#a10308',
    completedTextColor: '#ffffff',
    inactiveBgColor: '#C8C8C8',
    inactiveTextColor: 'transparent',
    size: '16px',
    circleFontSize: '0',
    labelFontSize: '0.875rem',
    borderRadius: '50%',
    fontWeight: 500
}

type FormValues = {
    niche_topics: (string | undefined)[] | undefined;
    unique_expertise: string;
    content_focus: string;
    creator_why: (string | undefined)[] | undefined;
    career_goals: string;
    success_definition: (string | undefined)[] | undefined;
    // ... other fields
    seo_algorithms: string;
};
interface name_type {
    name: string
}

interface category_type {
    category: string;
    output_text: string;
    user_name: string;
}

const ButterPie = () => {
    // Assume we have 8 steps (indexed 0-7)
    const totalSteps = 8;
    const [goSteps, setGoSteps] = useState<number>(1);
    const [errorSteps, setErrorSteps] = useState<number[]>([]);
    const [activeCategory, setActiveCategory] = useState<string>('Content Strategy & Branding');
    const [isStored, setIsStored] = useState<boolean>(true);
    const [isLinear, setIsLiear] = useState<boolean>(false);
    const [compareObj, setCompareObj] = useState<any>({});
    const [categoryObj, setCategoryObj] = useState<any>({});
    const [finalCategory, setFinalCategory] = useState<category_type[]>([])
    const dispatch = useDispatch();
    const capitalFirstLetterOfWord = (word: string | null) => {
        if (word !== null) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
    }

    let userSchema = object({
        niche_topics: array().of(string().min(1, "String cannot be empty")).min(1, "Please select a topic"),
        unique_expertise: string().required("Unique Expertise is required"),
        content_focus: string().required("Please select a category"),
        creator_why: array().of(string().min(1, "String cannot be empty")).min(1, "Please select a topic"),
        career_goals: string().required("Please select a category"),
        success_definition: array().of(string().min(1, "String cannot be empty")).min(1, "Please select a topic"),
        creation_skills: array().of(string().min(1, "String cannot be empty")).min(1, "Please select a topic"),
        comfort_level: array().of(string().min(1, "String cannot be empty")).min(1, "Please select a topic"),
        past_experience: string().required("Past Experience is required"),
        platform_preference: array().of(string().min(1, "String cannot be empty")).min(1, "Please select a topic"),
        content_format: string().required("Please select a category"),
        multichannel_strategy: string().required("Please select a category"),
        learning_willingness: string().required("Please select a category"),
        monetization_timing: string().required("Please select a category"),
        revenue_streams: array().of(string().min(1, "String cannot be empty")).min(1, "Please select a topic"),
        existing_business: string().required("Please select a category"),
        natural_talents: string().required("Natural Talents is required"),
        struggle_areas: string().required("Struggle Areas is required"),
        obstacles: string().required("Obstacles is required"),
        ai_tools_openness: string().required("Please select a category"),
        workflow_automation: string().required("Please select a category"),
        seo_algorithms: string().required("Please select a category"),
    })

    const handleRegenerateCategoryClick = async (category: string) => {
        dispatch(handleLoader(true));
        setActiveCategory(category)
        try {
            const { result, error } = await regenerateCategory(capitalFirstLetterOfWord(localStorage.getItem('firstName')) + ' ' + capitalFirstLetterOfWord(localStorage.getItem('lastName')), encodeURIComponent(category))
            if (error || result?.error) {
                throw error || result.error;
            }
            setCategoryObj(result);
            dispatch(handleLoader(false));
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const findCategory = (category_name: string, categoryArr: category_type[]) => {
        setActiveCategory(category_name)
        const temp: any = categoryArr.find((obj: category_type) => obj.category === category_name);
        setCategoryObj(temp);
    }
    const generateCategory = async (category_name: string) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getCategory(capitalFirstLetterOfWord(localStorage.getItem('firstName')) + ' ' + capitalFirstLetterOfWord(localStorage.getItem('lastName')))
            if (error || result?.error) {
                throw error || result.error;
            }
            dispatch(handleLoader(false));
            setFinalCategory(result);
            findCategory(category_name, result);
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const checkObj = (arr: any) => {
        const hasObject = arr.some(
            (item: any) =>
                typeof item === "object" &&
                item !== null
        );
        if (hasObject) {
            const temp = arr.map((item: any) => {
                if (typeof item === 'object') {
                    return 'other'
                } else {
                    return item
                }
            })
            return temp
        } else {
            return arr
        }
    }
    const giveValue = (arr: any) => {
        const hasObject = arr.some(
            (item: any) =>
                typeof item === "object" &&
                item !== null
        );
        const foundObj = arr.find(
            (item: any) =>
                typeof item === "object" && item !== null
        );
        if (hasObject) {
            return foundObj.other
        } else {
            return ''
        }
    }
    const list = ['education', 'entertainment', 'storytelling', 'community']
    const foundRadio = (arr: string) => {
        if (!list.includes(arr)) {
            return 'other'
        } else {
            return arr
        }
    }
    const radioValue = (arr: string) => {
        if (!list.includes(arr)) {
            return arr
        } else {
            return ''
        }
    }

    const methods = useForm<any>({
        // defaultValues: myconst.butterPieObj,
        defaultValues: async () => {
            dispatch(handleLoader(true));
            try {
                const { result, error } = await getButterPieConfigurations(capitalFirstLetterOfWord(localStorage.getItem('firstName')) + ' ' + capitalFirstLetterOfWord(localStorage.getItem('lastName')));
                if (error || result?.error) {
                    throw error || result.error;
                }
                setIsStored(result.is_record)
                setIsLiear(result?.is_record)
                if (result.is_record) {
                    await generateCategory('Content Strategy & Branding')
                }
                if (result.record === null) {
                    dispatch(handleLoader(false));
                    return myconst.butterPieObj
                }
                const valueObj = {
                    "niche_topics": checkObj(result.record.niche_interests.niche_topics),
                    "niche_topics_other": giveValue(result.record.niche_interests.niche_topics),
                    "unique_expertise": result.record.niche_interests.unique_expertise,
                    "content_focus": foundRadio(result.record.niche_interests.content_focus),
                    "content_focus_other": radioValue(result.record.niche_interests.content_focus),
                    "creator_why": result.record.goals_motivation.creator_why,
                    "career_goals": result.record.goals_motivation.career_goals,
                    "success_definition": checkObj(result.record.goals_motivation.success_definition),
                    "success_definition_other": giveValue(result.record.goals_motivation.success_definition),
                    "creation_skills": checkObj(result.record.skills_background.creation_skills),
                    "creation_skills_other": giveValue(result.record.skills_background.creation_skills),
                    "comfort_level": result.record.skills_background.comfort_level,
                    "past_experience": result.record.skills_background.past_experience,
                    "platform_preference": result.record.preferred_platforms.platform_preference,
                    "content_format": result.record.preferred_platforms.content_format,
                    "multichannel_strategy": result.record.preferred_platforms.multichannel_strategy,
                    "time_commitment": Number(result.record.available_resources_commitment.time_commitment),
                    "budget": Number(result.record.available_resources_commitment.budget),
                    "learning_willingness": result.record.available_resources_commitment.learning_willingness,
                    "monetization_timing": result.record.monetization_business_goals.monetization_timing,
                    "revenue_streams": result.record.monetization_business_goals.revenue_streams,
                    "existing_business": result.record.monetization_business_goals.existing_business,
                    "natural_talents": result.record.strengths_weaknesses.natural_talents,
                    "struggle_areas": result.record.strengths_weaknesses.obstacles,
                    "obstacles": result.record.strengths_weaknesses.struggle_areas,
                    "ai_tools_openness": result.record.comfort_with_ai_tech.ai_tools_openness,
                    "workflow_automation": result.record.comfort_with_ai_tech.workflow_automation,
                    "seo_algorithms": result.record.comfort_with_ai_tech.seo_algorithms
                }
                setCompareObj(result.record !== null ? valueObj : myconst.butterPieObj)
                dispatch(handleLoader(false));
                const temp = result.record !== null ? valueObj : myconst.butterPieObj
                return temp
            } catch (error) {
                dispatch(handleLoader(false));
                toast.error(error as ToastContent<unknown>, {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        },
        resolver: yupResolver(userSchema) as Resolver<any>,

    })
    const handleStes = (steps: number) => {
        switch (steps) {
            case 1:
                // return <StepOne handleNext={() => setGoSteps(1)} />
                return <StepOne methods={methods} setErrorSteps={setErrorSteps} isLinear={isLinear} goOnLast={() => setGoSteps(8)} handleNext={() => setGoSteps(2)} />
            case 2:
                return <StepTwo methods={methods} setErrorSteps={setErrorSteps} handlePrev={() => setGoSteps(1)} isLinear={isLinear} goOnLast={() => setGoSteps(8)} handleNext={() => setGoSteps(3)} />
            case 3:
                return <StepThree methods={methods} setErrorSteps={setErrorSteps} handlePrev={() => setGoSteps(2)} isLinear={isLinear} goOnFirst={() => setGoSteps(1)} goOnLast={() => setGoSteps(8)} handleNext={() => setGoSteps(4)} />
            case 4:
                return <StepFour methods={methods} setErrorSteps={setErrorSteps} handlePrev={() => setGoSteps(3)} isLinear={isLinear} goOnFirst={() => setGoSteps(1)} goOnLast={() => setGoSteps(8)} handleNext={() => setGoSteps(5)} />
            case 5:
                return <StepFive methods={methods} setErrorSteps={setErrorSteps} handlePrev={() => setGoSteps(4)} isLinear={isLinear} goOnFirst={() => setGoSteps(1)} goOnLast={() => setGoSteps(8)} handleNext={() => setGoSteps(6)} />
            case 6:
                return <StepSix methods={methods} setErrorSteps={setErrorSteps} handlePrev={() => setGoSteps(5)} isLinear={isLinear} goOnFirst={() => setGoSteps(1)} goOnLast={() => setGoSteps(8)} handleNext={() => setGoSteps(7)} />
            case 7:
                return <StepSeven methods={methods} setErrorSteps={setErrorSteps} handlePrev={() => setGoSteps(6)} isLinear={isLinear} goOnFirst={() => setGoSteps(1)} handleNext={() => setGoSteps(8)} />
            case 8:
                return <StepEight methods={methods} setErrorSteps={setErrorSteps} handlePrev={() => setGoSteps(7)} goOnFirst={() => setGoSteps(1)} />
        }
    }
    const otherFunc = (data: any, value: string) => {
        if (data.includes('other')) {
            return data.map((d: any) => {
                if (d === 'other') {
                    return { other: value }
                }
                else {
                    return d
                }
            })
        } else {
            return data;
        }
    }

    const tempFunc = (title: string, value: string) => {
        if (title === 'other') {
            return value
        }
        else {
            return title
        }
    }

    const onSubmit = async (data: any) => {
        dispatch(handleLoader(true));
        try {
            const tempObj = {
                client_env: localStorage.getItem('clientName'),
                is_update: !_.isEqual(compareObj, data),
                user_name: capitalFirstLetterOfWord(localStorage.getItem('firstName')) + ' ' + capitalFirstLetterOfWord(localStorage.getItem('lastName')),
                niche_interests: {
                    niche_topics: otherFunc(data.niche_topics, data.niche_topics_other),
                    unique_expertise: data.unique_expertise,
                    content_focus: tempFunc(data.content_focus, data.content_focus_other)
                },
                goals_motivation: {
                    creator_why: data.creator_why,
                    career_goals: data.career_goals,
                    success_definition: otherFunc(data.success_definition, data.success_definition_other)
                },
                skills_background: {
                    creation_skills: otherFunc(data.creation_skills, data.creation_skills_other),
                    comfort_level: data.comfort_level,
                    past_experience: data.past_experience
                },
                preferred_platforms: {
                    platform_preference: data.platform_preference,
                    content_format: data.content_format,
                    multichannel_strategy: data.multichannel_strategy
                },
                available_resources_commitment: {
                    time_commitment: String(data.time_commitment),
                    budget: String(data.budget),
                    learning_willingness: data.learning_willingness
                },
                monetization_business_goals: {
                    monetization_timing: data.monetization_timing,
                    revenue_streams: data.revenue_streams,
                    existing_business: data.existing_business
                },
                strengths_weaknesses: {
                    natural_talents: data.natural_talents,
                    struggle_areas: data.struggle_areas,
                    obstacles: data.obstacles
                },
                comfort_with_ai_tech: {
                    ai_tools_openness: data.ai_tools_openness,
                    workflow_automation: data.workflow_automation,
                    seo_algorithms: data.seo_algorithms
                }
            }
            // console.log('data', tempObj)
            const { result, error } = await addOrUpdateButterPieConfigurations(tempObj);
            if (error || result?.error) {
                throw error || result.error;
            }
            setIsStored(true)
            await generateCategory('Content Strategy & Branding')
            dispatch(handleLoader(false));
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const MarkdownRenderer = ({ content }: any) => {
        return (
            <ReactMarkdown
                components={{
                    // Paragraphs
                    p: ({ node, ...props }) => <p className={styles['markdown-paragraph']} {...props} />,
                    // Headings
                    h1: ({ node, ...props }) => (
                        <h1
                            className={styles['markdown-heading1']}
                            {...props}
                        />
                    ),
                    h2: ({ node, ...props }) => (
                        <h2
                            className={styles['markdown-heading2']}
                            {...props}
                        />
                    ),
                    h3: ({ node, ...props }) => (
                        <h3
                            className={styles['markdown-heading3']}
                            {...props}
                        />
                    ),
                    h4: ({ node, ...props }) => (
                        <h4
                            className={styles['markdown-heading4']}
                            {...props}
                        />
                    ),
                    h5: ({ node, ...props }) => (
                        <h5
                            className={styles['markdown-heading5']}
                            {...props}
                        />
                    ),
                    h6: ({ node, ...props }) => (
                        <h6
                            className={styles['markdown-heading6']}
                            {...props}
                        />
                    ),

                    // Lists
                    ul: ({ node, ...props }) => (
                        <ul
                            className={styles['markdown-unordered-list']}
                            {...props}
                        />
                    ),
                    ol: ({ node, ordered, ...props }) => (
                        <ol
                            className={styles['markdown-ordered-list']}
                            {...props}
                        />
                    ),

                    // List Items
                    li: ({ node, ordered, ...props }) => (
                        <li
                            className={styles['markdown-list-item']}
                            {...props}
                        />
                    ),

                    // Links
                    a: ({ node, ...props }: any) => (
                        <a
                            className={styles['markdown-link']}
                            href={node.href}
                            {...props}
                            target="_blank"
                        >
                            {props.children}
                        </a>
                    ),

                    // Code Blocks styling or auto formatting API response...
                    pre: ({ node, ...props }) => (
                        <pre
                            className={styles['markdown-code-block']}
                            {...props}
                        />
                    ),
                    code: ({ inline, node, ...props }) => {
                        if (inline) {
                            return (
                                <code
                                    className={styles['markdown-inline-code']}
                                    {...props}
                                />
                            );
                        }
                        return (
                            //     <SyntaxHighlighter language="javascript" >
                            //     {props.children}
                            // </SyntaxHighlighter>

                            <p>{props.children}</p>
                        );
                    },

                    // Blockquotes
                    blockquote: ({ node, ...props }) => (
                        <blockquote
                            className={styles['markdown-blockquote']}
                            {...props}
                        />
                    ),

                    // Images
                    img: ({ node, ...props }: any) => (
                        <img
                            className={styles['markdown-image']}
                            src={node.src}
                            alt={node.alt}
                            {...props}
                        />
                    ),

                    // Table Headers
                    th: ({ node, ...props }) => (
                        <th
                            className={styles['markdown-table-header']}
                            {...props}
                        />
                    ),

                    // Table Cells
                    td: ({ node, ...props }) => (
                        <td
                            className={styles['markdown-table-cell']}
                            {...props}
                        />
                    ),

                    // Add other components and styles as needed
                }}
            >
                {content}
            </ReactMarkdown>
        );
    };

    const generatePDF = async () => {
        dispatch(handleLoader(true));
        try {
            const data = {
                client_env: localStorage.getItem('clientName'),
                user_name: capitalFirstLetterOfWord(localStorage.getItem('firstName')) + ' ' + capitalFirstLetterOfWord(localStorage.getItem('lastName'))
            }
            const { result, error } = await generateButterPiePdf(data);
            if (error || result?.error) {
                throw error || result.error;
            }
            await myconst.downloadPdfFromBase64(result.pdf_base64, 'final_road_map')
            dispatch(handleLoader(false));
            toast.success(result.message)
        } catch (error) {
            dispatch(handleLoader(false));
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const steps = ['Niche &\nIntreset', 'Goals &\nMotivation', 'Skills &\nBackground', 'Preferred \nPlatforms', 'Available Resources &\nCommitment', 'Monetization &\nBusiness Goals', 'Strengths &\nWeaknesses', 'Comfort with AI &\nTech'];
    return (
        <>
            {!isStored ?
                <div className="content-wrapper configuration-section2">
                    <div className="card">
                        {/* <h4 className="admin-heading">Butter Pie</h4> */}
                        <FormProvider {...methods} >
                            <form onSubmit={methods.handleSubmit(onSubmit, (err) => {
                                toast.error(`In ${errorSteps.length > 1 ? 'steps' : 'step'} ${errorSteps.join(',')} ${Object.keys(err).length > 1 ? 'fields are' : 'field is'} empty. Please fill ${Object.keys(err).length > 1 ? 'them' : 'it'} up`)
                                console.log("onSubmit", err)
                            })}>
                                <Stepper nonLinear connectorStateColors activeStep={goSteps} styleConfig={{ ...defaultStyle, activeBgColor: "#5627D9", completedBgColor: "#5627D9" }}  >
                                    {steps.map((step_item: string, index: number) => (
                                        <Step key={index} className={goSteps === index + 1 ? 'completed' : ''} type="button" onClick={() => setGoSteps(index + 1)} label={`Step ${index + 1}`}><span style={{ whiteSpace: 'pre' }} className={errorSteps.includes(index + 1) ? `extra-info text-danger fw-bold` : 'extra-info'}>{step_item}</span></Step>
                                        // <Step type="button" onClick={() => setGoSteps(0)} label="Step 1"><span className="extra-info">Niche &<br />Intreset</span></Step>
                                    ))}
                                </Stepper>
                                {handleStes(goSteps)}
                            </form>
                        </FormProvider>
                    </div>
                </div>
                :
                <div className='content-wrapper'>
                    <div className="user-management-section">
                        <div className='d-flex flex-wrap'>
                            <div className='qmate-sidebar d-flex flex-column justify-content-between butter-pie-sidebar'>
                                <div className="accordion-item" >
                                    {myconst.categoriesOfButterPie.map((item: string) => (
                                        <h4 onClick={() => findCategory(item, finalCategory)} className={`accordion-header item-header-butterpie py-2 ${activeCategory === item ? 'active' : ''}`}>
                                            {item}
                                        </h4>
                                    ))}
                                </div>
                                {/* <div>
                                    <div>
                                        <Button label="Download pdf" icon="pi pi-download" rounded  />
                                    </div> */}
                                <div className='butter-pie-action-item'>
                                    <div className='w-full mb-1 d-flex justify-content-between'>
                                        <button type="button" className="outline-active-btn m-1" onClick={() => handleRegenerateCategoryClick(activeCategory)}>Regenerate Response</button>
                                        <button type="button" className="grey-outline-btn m-1" onClick={() => setIsStored(false)}>Retake Questionnarie</button>
                                    </div>
                                    <div className='w-full'>
                                        <button type="button" onClick={generatePDF} className="outline-btn w-full m-1">Download PDF</button>
                                    </div>
                                </div>
                                {/* </div> */}
                            </div>
                            <div className={`qmate-admin butter-pie-content`}>
                                <section
                                    className={`chat-component-main-section`}
                                >
                                    <h2 className='butter-pie-page-heading'>{categoryObj?.category}</h2>
                                    <div>
                                        <MarkdownRenderer content={categoryObj?.output_text} />
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ButterPie